export default __webpack_public_path__ + "static/media/youwon.520e8ddb.mp3";